var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70935 15.1857C7.9078 14.9872 7.9078 14.6648 7.70935 14.4663L1.37136 8.14072L7.70935 1.80274C7.9078 1.60429 7.9078 1.28181 7.70935 1.08336C7.5109 0.88491 7.18842 0.88491 6.98997 1.08336L0.304697 7.76863C0.205472 7.86786 0.15586 7.99189 0.15586 8.12832C0.15586 8.25235 0.205472 8.38879 0.304697 8.48801L6.98997 15.1733C7.18842 15.3841 7.5109 15.3841 7.70935 15.1857Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.27d81b7f309646112e3efd58d6ffc3a1.svg";
export { ForwardRef as ReactComponent };